// extracted by mini-css-extract-plugin
module.exports = {"container":"faq-module__container___Q8PKm","question":"faq-module__question___pwHjV","answer":"faq-module__answer___dyXfI","title":"faq-module__title___3SMO-"};